export default {
  SITE_LOAD_SUCCESS: 'SITE_LOAD_SUCCESS',
};
